import type { FrontModule } from "@core/modules";
import "./entree.css";
import { InspectionPage } from "./inspection";
import { ApplicationLeaseTab, Dashboard, LeasePage, LeasesPage, NewLeasePage } from "./landlord";
import { ClaimLeasePage, MyLeasePage, MyLeasesPage, SimulatorSignaturePage, TenantInspectionPage } from "./tenant";

// Module « entree » : bail et annexes, signature Youtrust (simulateur), suivi et relances, originaux, activation,
// état des lieux (entrée, sortie, hors connexion), comparaison, inventaire, dépôt de garantie, livret, remise des clés,
// espace locataire.
export const module: FrontModule = {
  name: "entree",
  orgRoutes: [
    { path: "baux", element: <LeasesPage /> },
    { path: "baux/nouveau", element: <NewLeasePage /> },
    { path: "baux/:leaseId", element: <LeasePage /> },
    { path: "baux/:leaseId/etats-des-lieux/:inspectionId", element: <InspectionPage /> },
  ],
  nav: [{ to: "baux", label: "Baux", section: "Gestion", perm: "read", order: 10 }],
  accountRoutes: [
    { path: "/moi/locations", element: <MyLeasesPage /> },
    { path: "/moi/locations/rattacher/:token", element: <ClaimLeasePage /> },
    { path: "/moi/locations/:leaseId", element: <MyLeasePage /> },
    { path: "/moi/locations/:leaseId/etats-des-lieux/:inspectionId", element: <TenantInspectionPage /> },
  ],
  accountNav: [{ to: "/moi/locations", label: "Ma location" }],
  publicRoutes: [{ path: "/simulateur-signature/:ref", element: <SimulatorSignaturePage /> }],
  Dashboard,
  applicationTabs: [
    {
      id: "entree-bail",
      label: "Préparer le bail",
      order: 80,
      Component: ApplicationLeaseTab,
      visible: ({ data }) => !["brouillon", "refusee", "retiree"].includes(data?.status),
    },
  ],
};
